import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-2x d-flex justify-content-center align-items-center text-muted w-100 h-100 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "carousel-indicators" }
const _hoisted_5 = ["data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_6 = { class: "slider-content text-center position-absolute m-auto text-light" }
const _hoisted_7 = { class: "fw-bold mb-3" }
const _hoisted_8 = ["href", "target"]
const _hoisted_9 = ["src", "alt", "id"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#picadoSlider\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#picadoSlider\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "picadoSlider",
    class: "carousel slide bg-dark",
    "data-bs-ride": "carousel",
    "data-bs-touch": "true",
    "data-bs-pause": "false",
    "data-bs-interval": "4000",
    style: _normalizeStyle(_ctx.$route.name == 'RestaurantPage' ? 'height: 60vh;' : 'height: 100vh')
  }, [
    (!_ctx.gallery || _ctx.gallery.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.id,
          type: "button",
          "data-bs-target": "#picadoSlider",
          "data-bs-slide-to": index,
          class: _normalizeClass(index == 0 ? 'active' : ''),
          "aria-current": index == 0 ? 'true' : '',
          "aria-label": item.tag_line
        }, null, 10, _hoisted_5))
      }), 128))
    ], 512), [
      [_vShow, _ctx.gallery && _ctx.gallery.length > 1]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["carousel-inner", _ctx.$route.name == 'RestaurantPage' ? 'featured': ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["carousel-item", index == 0 ? 'active' : ''])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString(item.tag_line), 1),
            (item.call_to_action_url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.call_to_action_url,
                  class: "btn btn-outline-primary rounded-5 btn-sm px-4 me-2 border-2 fw-bold",
                  target: item.open_as_new_page ? '_blank' : ''
                }, _toDisplayString(item.call_to_action_text), 9, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("img", {
            src: item.image,
            class: _normalizeClass(["d-block", _ctx.checkImageDimentions(`slider-${index}`)]),
            alt: item.tag_line,
            id: `slider-${index}`
          }, null, 10, _hoisted_9)
        ], 2))
      }), 128))
    ], 2),
    (_ctx.gallery && _ctx.gallery.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_10
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}